module.exports = __webpack_public_path__ + "static/media/addVehicle.ad90d945.svg";